import { yupResolver } from "@hookform/resolvers/yup";
import LoadingFormNormal from "components/shared-components/LoadingFormNormal";
import {
  AUTH_STATUS_NEW,
  REGISTRY_DELEGATE_FIELD,
} from "constants/FormatDataContanst";
import { english } from "flatpickr/dist/l10n/default";
import { Vietnamese } from "flatpickr/dist/l10n/vn";
import "flatpickr/dist/themes/material_blue.css";
import {
  generateDateField,
  generateDateFieldArray,
  generateInputField,
  generateInputFieldArray,
  generateSelectField,
  generateSelectFieldArray,
} from "helpers/form_helper_old";
import PropTypes from "prop-types";
import React, { useEffect, useRef, useState } from "react";
import { useFieldArray, useForm } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";
import {
  Button,
  Col,
  FormGroup,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Row,
  Table,
} from "reactstrap";
import {
  createRegistryDelegate,
  downloadXmlRegistryDelegate,
  editRegistryDelegate,
  getDetailRegistryDelegate,
} from "store/actions";
import * as yup from "yup";
import "../detailData.scss";
import {
  convertDate,
  formatTimestampToDate,
  initOptionDateLocale,
  MODE_FORM,
} from "../utils";
const DetailData = props => {
  const { isOpen, toggle, dataDetail, t, i18n, toggleReleaseModal } = props;
  const [optionDateLocale, setOptionDateLocale] = useState({
    ...initOptionDateLocale,
  });

  const modal = useRef(null);
  const [disableForm, setDisableForm] = useState(false);
  // Language Change
  useEffect(() => {
    const lang = i18n.language;
    switch (lang) {
      case "vn":
        setOptionDateLocale({
          ...optionDateLocale,
          locale: {
            ...Vietnamese,
            firstDayOfWeek: optionDateLocale.locale.firstDayOfWeek,
          },
        });
        break;
      case "en":
        setOptionDateLocale({
          ...optionDateLocale,
          locale: {
            ...english,
            firstDayOfWeek: optionDateLocale.locale.firstDayOfWeek,
          },
        });
        break;
      default:
        break;
    }
  }, [t]);

  const dispatch = useDispatch();
  // store reducer

  const dataFormat = useSelector(state => state.dataFormat);
  const {
    loading: loadingDetail,
    data: detailRegistryDelegate,
    error,
  } = dataFormat.detailRegistryDelegate;

  const { loading: loadingSubmitCreate, error: errorSubmitCreate } =
    dataFormat.createRegistryDelegate;

  const { loading: loadingSubmitEdit, error: errorSubmitEdit } =
    dataFormat.editRegistryDelegate;

  useEffect(() => {
    return () => {};
  }, []);

  const COMMON_FIELD = REGISTRY_DELEGATE_FIELD.COMMON;
  const LIST_CAS_FIELD = REGISTRY_DELEGATE_FIELD.LIST_CAS;
  const LIST_INVOICES_FIELD = REGISTRY_DELEGATE_FIELD.LIST_INVOICES;

  useEffect(() => {
    if (isOpen) {
      checkDisableForm();
      reset();
      addNewLineCAS();
      addNewLineInvoices();
      if (dataDetail?.id) {
        dispatch(getDetailRegistryDelegate(dataDetail.id));
      }
      setTimeout(() => {
        if (modal && modal.current) {
          modal.current.scrollTop = 0;
          setFocus(COMMON_FIELD.TNNT.field);
        }
      });
    }
  }, [isOpen]);

  const checkDisableForm = () => {
    if (dataDetail?.mode === MODE_FORM.VIEW) {
      setDisableForm(true);
    } else {
      setDisableForm(false);
    }
  };

  useEffect(() => {
    if (detailRegistryDelegate) {
      // Set default value COMMON_FIELD
      setDefaultValue(COMMON_FIELD);
      // Set default value listCAS
      const registryDelegateCas = detailRegistryDelegate.registryDelegateCas;
      if (registryDelegateCas && registryDelegateCas.length > 0) {
        setValue(
          LIST_CAS_FIELD.field,
          registryDelegateCas.map(item => {
            const tngay = formatTimestampToDate(item.tngay);
            const dngay = formatTimestampToDate(item.dngay);
            return {
              ttchuc: item.ttchuc,
              seri: item.seri,
              tngay: [tngay, dngay],
              hthuc: OPTION_CA_HTHUC.find(
                option => Number(option.value) === Number(item.hthuc)
              ),
            };
          })
        );
      }
      // Set default value listInvoices
      const registryDelegateInvoices =
        detailRegistryDelegate.registryDelegateInvoices;
      if (registryDelegateInvoices && registryDelegateInvoices.length > 0) {
        setValue(
          LIST_INVOICES_FIELD.field,
          registryDelegateInvoices.map(item => {
            const tngay = formatTimestampToDate(item.tngay);
            const dngay = formatTimestampToDate(item.dngay);
            return {
              tlhdon: item.tlhdon,
              khmshdon: OPTION_KHMSHDON.find(
                option => Number(option.value) === Number(item.khmshdon)
              ),
              khhdon: item.khhdon,
              mst: item.mst,
              ttchuc: item.ttchuc,
              mdich: item.mdich,
              tngay: [tngay, dngay],
              pthuc: item.pthuc,
            };
          })
        );
      }
    }
  }, [detailRegistryDelegate]);

  // Custom set default value
  const setDefaultValue = FIELDS => {
    for (const key in FIELDS) {
      const finalKey = FIELDS[key].field;
      const type = FIELDS[key].type;
      const finalValue = detailRegistryDelegate[finalKey];
      if (finalValue) {
        switch (type) {
          case "select":
            const option = OPTION_GROUP[finalKey];
            const valueSelect = option.find(
              item => Number(item.value) === Number(finalValue)
            );
            setValue(finalKey, valueSelect);
            break;
          case "text":
            setValue(finalKey, finalValue);
            break;
          case "date":
            const date = formatTimestampToDate(finalValue);
            setValue(finalKey, [date]);
            break;
        }
      }
    }
  };

  const schema = yup.object().shape({
    // THông tin chung
    [COMMON_FIELD.PBAN.field]: yup
      .string()
      .required(
        t("form.validate.required", {
          title: t(`field.${COMMON_FIELD.PBAN.field}`),
        })
      )
      .max(
        COMMON_FIELD.PBAN.max,
        t("form.validate.char_max", { max: COMMON_FIELD.PBAN.max })
      ),
    [COMMON_FIELD.MSO.field]: yup
      .string()
      .required(
        t("form.validate.required", {
          title: t(`field.${COMMON_FIELD.MSO.field}`),
        })
      )
      .max(
        COMMON_FIELD.MSO.max,
        t("form.validate.char_max", { max: COMMON_FIELD.MSO.max })
      ),
    [COMMON_FIELD.TEN.field]: yup
      .string()
      .required(
        t("form.validate.required", {
          title: t(`field.${COMMON_FIELD.TEN.field}`),
        })
      )
      .max(
        COMMON_FIELD.TEN.max,
        t("form.validate.char_max", { max: COMMON_FIELD.TEN.max })
      ),
    [COMMON_FIELD.LDKUNHIEM.field]: yup.object().required(
      t("form.validate.select", {
        title: t(`field.${COMMON_FIELD.LDKUNHIEM.field}`),
      })
    ),
    [COMMON_FIELD.TNNT.field]: yup
      .string()
      .required(
        t("form.validate.required", {
          title: t(`field.${COMMON_FIELD.TNNT.field}`),
        })
      )
      .max(
        COMMON_FIELD.TNNT.max,
        t("form.validate.char_max", { max: COMMON_FIELD.TNNT.max })
      ),
    [COMMON_FIELD.MST.field]: yup
      .string()
      .required(
        t("form.validate.required", {
          title: t(`field.${COMMON_FIELD.MST.field}`),
        })
      )
      .test(
        "len",
        "Vui lòng nhập 10 hoặc 14 ký tự",
        val => val.length === 0 || val.length === 10 || val.length === 14
      ),
    [COMMON_FIELD.CQTQLY.field]: yup
      .string()
      .required(
        t("form.validate.required", {
          title: t(`field.${COMMON_FIELD.CQTQLY.field}`),
        })
      )
      .max(
        COMMON_FIELD.CQTQLY.max,
        t("form.validate.char_max", { max: COMMON_FIELD.CQTQLY.max })
      ),
    [COMMON_FIELD.MCQTQLY.field]: yup
      .string()
      .required(
        t("form.validate.required", {
          title: t(`field.${COMMON_FIELD.MCQTQLY.field}`),
        })
      )
      .max(
        COMMON_FIELD.MCQTQLY.max,
        t("form.validate.char_max", { max: COMMON_FIELD.MCQTQLY.max })
      ),
    [COMMON_FIELD.NLHE.field]: yup
      .string()
      .required(
        t("form.validate.required", {
          title: t(`field.${COMMON_FIELD.NLHE.field}`),
        })
      )
      .max(
        COMMON_FIELD.NLHE.max,
        t("form.validate.char_max", { max: COMMON_FIELD.NLHE.max })
      ),
    [COMMON_FIELD.DCLHE.field]: yup
      .string()
      .required(
        t("form.validate.required", {
          title: t(`field.${COMMON_FIELD.DCLHE.field}`),
        })
      )
      .max(
        COMMON_FIELD.DCLHE.max,
        t("form.validate.char_max", { max: COMMON_FIELD.DCLHE.max })
      ),
    [COMMON_FIELD.DCTDTU.field]: yup
      .string()
      .required(
        t("form.validate.required", {
          title: t(`field.${COMMON_FIELD.DCTDTU.field}`),
        })
      )
      .email(
        t("form.validate.invalid", {
          title: t(`field.${COMMON_FIELD.DCTDTU.field}`),
        })
      )
      .max(
        COMMON_FIELD.DCTDTU.max,
        t("form.validate.char_max", { max: COMMON_FIELD.DCTDTU.max })
      ),
    [COMMON_FIELD.DTLHE.field]: yup
      .string()
      .required(
        t("form.validate.required", {
          title: t(`field.${COMMON_FIELD.DTLHE.field}`),
        })
      )
      .max(
        COMMON_FIELD.DTLHE.max,
        t("form.validate.char_max", { max: COMMON_FIELD.DTLHE.max })
      ),
    [COMMON_FIELD.DDANH.field]: yup
      .string()
      .required(
        t("form.validate.required", {
          title: t(`field.${COMMON_FIELD.DDANH.field}`),
        })
      )
      .max(
        COMMON_FIELD.DDANH.max,
        t("form.validate.char_max", { max: COMMON_FIELD.DDANH.max })
      ),
    [COMMON_FIELD.NLAP.field]: yup.array().min(
      1,
      t("form.validate.select", {
        title: t(`field.${COMMON_FIELD.NLAP.field}`),
      })
    ),
    // Thông tin chứng thư số sử dụng
    [LIST_CAS_FIELD.field]: yup
      .array()
      .min(1, t("form.validate.least_one_line"))
      .of(
        yup.object().shape({
          [LIST_CAS_FIELD.TTCHUC.field]: yup
            .string()
            .required(
              t("form.validate.required", {
                title: t(
                  `field.listRegistryDelegateCas.${LIST_CAS_FIELD.TTCHUC.field}`
                ),
              })
            )
            .max(
              LIST_CAS_FIELD.TTCHUC.max,
              t("form.validate.char_max", { max: LIST_CAS_FIELD.TTCHUC.max })
            ),
          [LIST_CAS_FIELD.SERI.field]: yup
            .string()
            .required(
              t("form.validate.required", {
                title: t(
                  `field.listRegistryDelegateCas.${LIST_CAS_FIELD.SERI.field}`
                ),
              })
            )
            .max(
              LIST_CAS_FIELD.SERI.max,
              t("form.validate.char_max", { max: LIST_CAS_FIELD.SERI.max })
            ),
          [LIST_CAS_FIELD.HTHUC.field]: yup.object().required(
            t("form.validate.select", {
              title: t(
                `field.listRegistryDelegateCas.${LIST_CAS_FIELD.HTHUC.field}`
              ),
            })
          ),
          [LIST_CAS_FIELD.TNGAY.field]: yup.array().min(
            2,
            t("form.validate.select", {
              title: t(`field.listRegistryDelegateCas.timeUse`),
            })
          ),
        })
      ),
    // danh sách đăng ký
    [LIST_INVOICES_FIELD.field]: yup
      .array()
      .min(1, t("form.validate.least_one_line"))
      .of(
        yup.object().shape({
          [LIST_INVOICES_FIELD.TLHDON.field]: yup
            .string()
            .required(
              t("form.validate.required", {
                title: t(
                  `field.listRegistryDelegateInvoices.${LIST_INVOICES_FIELD.TLHDON.field}`
                ),
              })
            )
            .max(
              LIST_INVOICES_FIELD.TLHDON.max,
              t("form.validate.char_max", {
                max: LIST_INVOICES_FIELD.TLHDON.max,
              })
            ),
          [LIST_INVOICES_FIELD.KHMSHDON.field]: yup.object().required(
            t("form.validate.select", {
              title: t(
                `field.listRegistryDelegateInvoices.${LIST_INVOICES_FIELD.KHMSHDON.field}`
              ),
            })
          ),
          [LIST_INVOICES_FIELD.KHHDON.field]: yup
            .string()
            .required(
              t("form.validate.required", {
                title: t(
                  `field.listRegistryDelegateInvoices.${LIST_INVOICES_FIELD.KHHDON.field}`
                ),
              })
            )
            .max(
              LIST_INVOICES_FIELD.KHHDON.max,
              t("form.validate.char_max", {
                max: LIST_INVOICES_FIELD.KHHDON.max,
              })
            ),
          [LIST_INVOICES_FIELD.MST.field]: yup
            .string()
            .required(
              t("form.validate.required", {
                title: t(
                  `field.listRegistryDelegateInvoices.${LIST_INVOICES_FIELD.MST.field}`
                ),
              })
            )
            .test(
              "len",
              "Vui lòng nhập 10 hoặc 14 ký tự",
              val => val.length === 0 || val.length === 10 || val.length === 14
            ),
          [LIST_INVOICES_FIELD.TTCHUC.field]: yup
            .string()
            .required(
              t("form.validate.required", {
                title: t(
                  `field.listRegistryDelegateInvoices.${LIST_INVOICES_FIELD.TTCHUC.field}`
                ),
              })
            )
            .max(
              LIST_INVOICES_FIELD.TTCHUC.max,
              t("form.validate.char_max", {
                max: LIST_INVOICES_FIELD.TTCHUC.max,
              })
            ),
          [LIST_INVOICES_FIELD.MDICH.field]: yup
            .string()
            .required(
              t("form.validate.required", {
                title: t(
                  `field.listRegistryDelegateInvoices.${LIST_INVOICES_FIELD.MDICH.field}`
                ),
              })
            )
            .max(
              LIST_INVOICES_FIELD.MDICH.max,
              t("form.validate.char_max", {
                max: LIST_INVOICES_FIELD.MDICH.max,
              })
            ),
          [LIST_INVOICES_FIELD.TNGAY.field]: yup.array().min(
            2,
            t("form.validate.select", {
              title: t(`field.listRegistryDelegateInvoices.timeUse`),
            })
          ),
          [LIST_INVOICES_FIELD.PTHUC.field]: yup
            .string()
            .required(
              t("form.validate.required", {
                title: t(
                  `field.listRegistryDelegateInvoices.${LIST_INVOICES_FIELD.PTHUC.field}`
                ),
              })
            )
            .max(
              LIST_INVOICES_FIELD.PTHUC.max,
              t("form.validate.char_max", {
                max: LIST_INVOICES_FIELD.PTHUC.max,
              })
            ),
        })
      ),
  });

  const OPTION_DELEGATE = [
    {
      value: COMMON_FIELD.LDKUNHIEM.selectValues.DELEGATE,
      label: t("select.delegate"),
    },
    {
      value: COMMON_FIELD.LDKUNHIEM.selectValues.GET_MANDATE,
      label: t("select.getMandate"),
    },
  ];

  const OPTION_CA_HTHUC = [
    {
      value: LIST_CAS_FIELD.HTHUC.selectValues.ADD,
      label: t("select.add"),
    },
    {
      value: LIST_CAS_FIELD.HTHUC.selectValues.EXTEND,
      label: t("select.extend"),
    },
    {
      value: LIST_CAS_FIELD.HTHUC.selectValues.STOP_USE,
      label: t("select.stopUse"),
    },
  ];

  const OPTION_KHMSHDON = [
    {
      value: LIST_INVOICES_FIELD.KHMSHDON.selectValues.KHMSHDON_1,
      label:
        LIST_INVOICES_FIELD.KHMSHDON.selectValues.KHMSHDON_1 +
        " ( " +
        t("select.khmshdon_1") +
        " )",
    },
    {
      value: LIST_INVOICES_FIELD.KHMSHDON.selectValues.KHMSHDON_2,
      label:
        LIST_INVOICES_FIELD.KHMSHDON.selectValues.KHMSHDON_2 +
        " ( " +
        t("select.khmshdon_2") +
        " )",
    },
    {
      value: LIST_INVOICES_FIELD.KHMSHDON.selectValues.KHMSHDON_3,
      label:
        LIST_INVOICES_FIELD.KHMSHDON.selectValues.KHMSHDON_3 +
        " ( " +
        t("select.khmshdon_3") +
        " )",
    },
    {
      value: LIST_INVOICES_FIELD.KHMSHDON.selectValues.KHMSHDON_4,
      label:
        LIST_INVOICES_FIELD.KHMSHDON.selectValues.KHMSHDON_4 +
        " ( " +
        t("select.khmshdon_4") +
        " )",
    },
    {
      value: LIST_INVOICES_FIELD.KHMSHDON.selectValues.KHMSHDON_5,
      label:
        LIST_INVOICES_FIELD.KHMSHDON.selectValues.KHMSHDON_5 +
        " ( " +
        t("select.khmshdon_5") +
        " )",
    },
    {
      value: LIST_INVOICES_FIELD.KHMSHDON.selectValues.KHMSHDON_6,
      label:
        LIST_INVOICES_FIELD.KHMSHDON.selectValues.KHMSHDON_6 +
        " ( " +
        t("select.khmshdon_6") +
        " )",
    },
  ];

  const OPTION_GROUP = {
    [COMMON_FIELD.LDKUNHIEM.field]: OPTION_DELEGATE,
    [LIST_CAS_FIELD.HTHUC.field]: OPTION_CA_HTHUC,
    [LIST_INVOICES_FIELD.KHMSHDON.field]: OPTION_KHMSHDON,
  };

  const {
    handleSubmit,
    reset,
    formState: { errors, touchedFields, isSubmitting },
    control,
    setValue,
    getValues,
    setError,
    register,
    unregister,
    trigger,
    setFocus,
  } = useForm({
    resolver: yupResolver(schema),
    mode: "all",
    reValidateMode: "onChange",
    defaultValues: {
      [COMMON_FIELD.PBAN.field]: "2.0.0",
      [COMMON_FIELD.MSO.field]: "01/ĐKTĐ-HĐĐT",
      [COMMON_FIELD.MST.field]: "",
      [COMMON_FIELD.NLAP.field]: [new Date()],
      [COMMON_FIELD.TEN.field]:
        "Tờ khai đăng ký thay đổi thông tin đăng ký sử dụng HĐĐT khi ủy nhiệm/nhận ủy nhiệm lập hoá đơn",
    },
  });

  const {
    fields: fieldsCAS,
    append: appendCAS,
    remove: removeCAS,
  } = useFieldArray({
    control, // control props comes from useForm (optional: if you are using FormContext)
    name: LIST_CAS_FIELD.field, // unique name for your Field Array
    keyName: "key", // keyName: "id", default to "id", you can change the key name
  });

  const {
    fields: fieldsInvoices,
    append: appendInvoices,
    remove: removeInvoices,
  } = useFieldArray({
    control, // control props comes from useForm (optional: if you are using FormContext)
    name: LIST_INVOICES_FIELD.field, // unique name for your Field Array
    keyName: "key", // keyName: "id", default to "id", you can change the key name
  });

  const defaultValueLineCAS = {
    [LIST_CAS_FIELD.TTCHUC.field]: undefined,
    [LIST_CAS_FIELD.SERI.field]: undefined,
    [LIST_CAS_FIELD.HTHUC.field]: undefined,
    [LIST_CAS_FIELD.TNGAY.field]: [],
  };

  const defaultValueLineInvoices = {
    [LIST_INVOICES_FIELD.TLHDON.field]: undefined,
    [LIST_INVOICES_FIELD.KHMSHDON.field]: undefined,
    [LIST_INVOICES_FIELD.KHHDON.field]: undefined,
    [LIST_INVOICES_FIELD.MST.field]: "",
    [LIST_INVOICES_FIELD.TTCHUC.field]: undefined,
    [LIST_INVOICES_FIELD.MDICH.field]: undefined,
    [LIST_INVOICES_FIELD.TNGAY.field]: [],
    [LIST_INVOICES_FIELD.PTHUC.field]: undefined,
  };

  const addNewLineCAS = () => {
    appendCAS(defaultValueLineCAS);
  };

  const addNewLineInvoices = () => {
    appendInvoices(defaultValueLineInvoices);
  };

  const submitForm = values => {
    // console.log("values", values);
    const finalData = formatData(values);
    if (dataDetail.id) {
      dispatch(editRegistryDelegate(finalData, dataDetail.id));
    } else {
      dispatch(createRegistryDelegate(finalData));
    }
  };

  const formatListCAsData = data => {
    const listCAs = [];
    let stt = 0;
    for (const item of data) {
      const childData = {};
      stt = stt + 1;
      for (const keyItem in item) {
        const dataChild = item[keyItem];
        childData[LIST_CAS_FIELD.STT.field] = stt;
        // get From Date
        if (Array.isArray(dataChild)) {
          childData[LIST_CAS_FIELD.TNGAY.field] = convertDate(dataChild[0]);
          childData[LIST_CAS_FIELD.DNGAY.field] = convertDate(dataChild[1]);
        } else if (typeof dataChild === "object" && dataChild !== null) {
          // get value from select
          childData[keyItem] = dataChild.value;
        } else {
          // get value text
          childData[keyItem] = dataChild;
        }
      }
      listCAs.push(childData);
    }
    return listCAs;
  };

  const formatData = values => {
    const finalData = {};
    for (const key in values) {
      const data = values[key];
      if (key === LIST_CAS_FIELD.field) {
        finalData[LIST_CAS_FIELD.field] = formatListCAsData(data);
      } else if (key === LIST_INVOICES_FIELD.field) {
        finalData[LIST_INVOICES_FIELD.field] = formatListCAsData(data);
      } else {
        //get From Date
        if (Array.isArray(data)) {
          finalData[key] = convertDate(data[0]);
        } else if (typeof data === "object" && data !== null) {
          // get value from select
          finalData[key] = data.value;
        } else {
          // get value text
          finalData[key] = data;
        }
      }
    }
    return finalData;
  };

  const generateTableInvoices = (
    fieldContanst,
    listContanst,
    fieldsArray,
    removeFunc,
    addFunc,
    isAuto = false,
    styleTable = {}
  ) => {
    return (
      <div className="custom-table-border" style={{ ...styleTable }}>
        <Table className="table  table-bordered">
          <thead>
            <tr>
              <th className="text-center" style={{ width: "20px" }}>
                STT
              </th>
              {Object.entries(listContanst)
                .filter(([k, v]) => !v.isHide && k !== "field" && k !== "DNGAY")
                .map(([key, value]) => {
                  let header = t(
                    `field.listRegistryDelegateInvoices.${value.field}`
                  );
                  if (key === "TNGAY") {
                    header = "Thời hạn ủy nhiệm";
                  }
                  return (
                    <th
                      style={{ width: value.width }}
                      className="text-center"
                      key={key}
                    >
                      {header}
                      {value.required && (
                        <span className="text-danger"> (*)</span>
                      )}
                    </th>
                  );
                })}
              {!isAuto && <th style={{ width: "20px" }}></th>}
            </tr>
          </thead>
          <tbody>
            {fieldsArray.map((field, index) => {
              const fieldMain = fieldContanst;
              const listField = listContanst;
              const arrayField = [];
              for (const key in listField) {
                if (
                  !listField[key].isHide &&
                  key !== "field" &&
                  key !== "DNGAY"
                ) {
                  arrayField.push(key);
                }
              }
              const tdStyle = {
                display: "table-cell",
                verticalAlign: "bottom",
              };
              return (
                <tr key={field.key}>
                  <td>{index + 1}</td>
                  {arrayField.map(item => {
                    const itemField = listField[item];
                    let watchDisable = disableForm;
                    switch (itemField.type) {
                      case "text":
                      case "number":
                        return (
                          <td style={tdStyle} key={item}>
                            {generateInputFieldArray(
                              t(`form.${itemField.field}`),
                              itemField.required,
                              itemField.type,
                              errors,
                              touchedFields,
                              fieldMain,
                              index,
                              itemField.field,
                              !itemField.disabled
                                ? t("placeholder.enter", {
                                    title: t(`form.${itemField.field}`),
                                  })
                                : "",
                              register,
                              watchDisable,
                              null,
                              control,
                              false,
                              false,
                              itemField.isTaxCode
                            )}
                          </td>
                        );
                      case "select":
                        return (
                          <td style={tdStyle} key={item}>
                            {generateSelectFieldArray(
                              t(`form.${itemField.field}`),
                              itemField.required,
                              errors,
                              touchedFields,
                              fieldMain,
                              index,
                              itemField.field,
                              !itemField.disabled
                                ? t("placeholder.select")
                                : "",
                              watchDisable,
                              control,
                              OPTION_GROUP[itemField.field],
                              null,
                              "top"
                            )}
                          </td>
                        );
                      case "date":
                        return (
                          <td style={tdStyle} key={item}>
                            {generateDateFieldArray(
                              "Từ ngày",
                              "Đến ngày",
                              itemField.required,
                              errors,
                              touchedFields,
                              fieldContanst,
                              index,
                              itemField.field,
                              "DD/MM/YYYY hh - DD/MM/YYYY hh",
                              dataDetail?.mode === MODE_FORM.VIEW,
                              control,
                              {
                                ...optionDateLocale,
                                mode: "range",
                                enableTime: true,
                                dateFormat: "H:i",
                                time_24hr: true,
                              }
                            )}
                          </td>
                        );
                      default:
                        break;
                    }
                  })}
                  {!isAuto && (
                    <td>
                      {dataDetail?.mode !== MODE_FORM.VIEW && (
                        <React.Fragment>
                          <div className="action-icon text-center d-flex gap-2 align-items-center justify-content-center">
                            {fieldsArray.length > 1 && (
                              <i
                                onClick={() => {
                                  removeFunc(index);
                                }}
                                className="mdi mdi-trash-can  text-danger font-size-18"
                                style={{ cursor: "pointer" }}
                              />
                            )}

                            {index === fieldsArray.length - 1 && (
                              <i
                                onClick={addFunc}
                                className="fas fa-plus  text-primary label-icon"
                                style={{ cursor: "pointer" }}
                              ></i>
                            )}
                          </div>
                        </React.Fragment>
                      )}
                    </td>
                  )}
                </tr>
              );
            })}
          </tbody>
        </Table>
      </div>
    );
  };

  const generateTableCAS = (
    fieldContanst,
    listContanst,
    fieldsArray,
    removeFunc,
    addFunc,
    isAuto = false,
    styleTable = {}
  ) => {
    return (
      <div className="custom-table-border" style={{ ...styleTable }}>
        <Table className="table  table-bordered">
          <thead>
            <tr>
              <th className="text-center" style={{ width: "20px" }}>
                STT
              </th>
              {Object.entries(listContanst)
                .filter(([k, v]) => !v.isHide && k !== "field" && k !== "DNGAY")
                .map(([key, value]) => {
                  let header = t(
                    `field.listRegistryDelegateCas.${value.field}`
                  );
                  if (key === "TNGAY") {
                    header = "Thời hạn sử dụng chứng thư số";
                  }
                  return (
                    <th
                      style={{ width: value.width }}
                      className="text-center"
                      key={key}
                    >
                      {header}
                      {value.required && (
                        <span className="text-danger"> (*)</span>
                      )}
                    </th>
                  );
                })}
              {!isAuto && <th style={{ width: "20px" }}></th>}
            </tr>
          </thead>
          <tbody>
            {fieldsArray.map((field, index) => {
              const fieldMain = fieldContanst;
              const listField = listContanst;
              const arrayField = [];
              for (const key in listField) {
                if (
                  !listField[key].isHide &&
                  key !== "field" &&
                  key !== "DNGAY"
                ) {
                  arrayField.push(key);
                }
              }
              const tdStyle = {
                display: "table-cell",
                verticalAlign: "bottom",
              };
              return (
                <tr key={field.key}>
                  <td>{index + 1}</td>
                  {arrayField.map(item => {
                    const itemField = listField[item];
                    let watchDisable = disableForm;
                    switch (itemField.type) {
                      case "text":
                      case "number":
                        return (
                          <td style={tdStyle} key={item}>
                            {generateInputFieldArray(
                              t(`form.${itemField.field}`),
                              itemField.required,
                              itemField.type,
                              errors,
                              touchedFields,
                              fieldMain,
                              index,
                              itemField.field,
                              !itemField.disabled
                                ? t("placeholder.enter", {
                                    title: t(`form.${itemField.field}`),
                                  })
                                : "",
                              register,
                              watchDisable
                            )}
                          </td>
                        );
                      case "select":
                        return (
                          <td style={tdStyle} key={item}>
                            {generateSelectFieldArray(
                              t(`form.${itemField.field}`),
                              itemField.required,
                              errors,
                              touchedFields,
                              fieldMain,
                              index,
                              itemField.field,
                              !itemField.disabled
                                ? t("placeholder.select")
                                : "",
                              watchDisable,
                              control,
                              OPTION_GROUP[itemField.field],
                              null,
                              "top"
                            )}
                          </td>
                        );
                      case "date":
                        return (
                          <td style={tdStyle} key={item}>
                            {generateDateFieldArray(
                              "Từ ngày",
                              "Đến ngày",
                              itemField.required,
                              errors,
                              touchedFields,
                              fieldContanst,
                              index,
                              itemField.field,
                              "DD/MM/YYYY hh - DD/MM/YYYY hh",
                              dataDetail?.mode === MODE_FORM.VIEW,
                              control,
                              {
                                ...optionDateLocale,
                                mode: "range",
                                enableTime: true,
                                dateFormat: "H:i",
                                time_24hr: true,
                              }
                            )}
                          </td>
                        );
                      default:
                        break;
                    }
                  })}
                  {!isAuto && (
                    <td>
                      {dataDetail?.mode !== MODE_FORM.VIEW && (
                        <React.Fragment>
                          <div className="action-icon text-center d-flex gap-2 align-items-center justify-content-center">
                            {fieldsArray.length > 1 && (
                              <i
                                onClick={() => {
                                  removeFunc(index);
                                }}
                                className="mdi mdi-trash-can  text-danger font-size-18"
                                style={{ cursor: "pointer" }}
                              />
                            )}

                            {index === fieldsArray.length - 1 && (
                              <i
                                onClick={addFunc}
                                className="fas fa-plus  text-primary label-icon"
                                style={{ cursor: "pointer" }}
                              ></i>
                            )}
                          </div>
                        </React.Fragment>
                      )}
                    </td>
                  )}
                </tr>
              );
            })}
          </tbody>
        </Table>
      </div>
    );
  };

  return (
    <Modal
      size="lg"
      contentClassName="detail-data-format"
      style={{ maxWidth: "95%" }}
      //   contentClassName="custom-modal-style"
      isOpen={isOpen}
      role="dialog"
      autoFocus={true}
      centered={true}
      className="exampleModal"
      tabIndex="-1"
      toggle={toggle}
    >
      <div className="modal-content">
        <ModalHeader toggle={toggle}>
          {t(`modal.title.${dataDetail?.mode}`)}
        </ModalHeader>
        {loadingDetail ? (
          <ModalBody>
            <LoadingFormNormal
              countInput="3"
              countButton="1"
              formClass="row-cols-1 row-cols-md-2"
              buttonClass="justify-content-end"
              buttonColClass="col-3"
            />
          </ModalBody>
        ) : (
          <React.Fragment>
            <ModalBody>
              <div
                ref={modal}
                style={{
                  maxHeight: "74vh",
                  overflow: "auto",
                  paddingLeft: "20px",
                  paddingRight: "20px",
                }}
              >
                <div className="custom-form-heading">
                  <i className="bx bx-info-circle text-primary"></i>
                  <strong> {t("modal.title.basic")}</strong>
                </div>
                <Row className="row-cols-1 row-cols-md-2">
                  {/* Phiên bản XML */}
                  {/* <Col>
                            <FormGroup className="mb-2">
                              {generateInputField(
                                t(`field.${COMMON_FIELD.PBAN.field}`),
                                true,
                                "text",
                                errors,
                                touchedFields,
                                COMMON_FIELD.PBAN.field,
                                t("placeholder.enter", {
                                  title: t(`field.${COMMON_FIELD.PBAN.field}`),
                                }),
                                register,
                                true
                              )}
                            </FormGroup>
                          </Col> */}
                  {/* Tên người nộp thuế */}
                  <Col>
                    <FormGroup className="mb-2">
                      {generateInputField(
                        t(`field.${COMMON_FIELD.TNNT.field}`),
                        true,
                        "text",
                        errors,
                        touchedFields,
                        COMMON_FIELD.TNNT.field,
                        t("placeholder.enter", {
                          title: t(`field.${COMMON_FIELD.TNNT.field}`),
                        }),
                        register,
                        disableForm
                      )}
                    </FormGroup>
                  </Col>
                  {/* Tên tờ khai */}
                  <Col>
                    <FormGroup className="mb-2">
                      {generateInputField(
                        t(`field.${COMMON_FIELD.TEN.field}`),
                        true,
                        "text",
                        errors,
                        touchedFields,
                        COMMON_FIELD.TEN.field,
                        t("placeholder.enter", {
                          title: t(`field.${COMMON_FIELD.TEN.field}`),
                        }),
                        register,
                        true
                      )}
                    </FormGroup>
                  </Col>
                  {/* Loại đăng ký ủy nhiệm */}
                  <Col>
                    <FormGroup className="mb-2">
                      {generateSelectField(
                        t(`field.${COMMON_FIELD.LDKUNHIEM.field}`),
                        true,
                        errors,
                        COMMON_FIELD.LDKUNHIEM.field,
                        t("placeholder.select"),
                        disableForm,
                        control,
                        OPTION_DELEGATE
                      )}
                    </FormGroup>
                  </Col>
                  {/* Mẫu số tờ khai */}
                  <Col>
                    <FormGroup className="mb-2">
                      {generateInputField(
                        t(`field.${COMMON_FIELD.MSO.field}`),
                        true,
                        "text",
                        errors,
                        touchedFields,
                        COMMON_FIELD.MSO.field,
                        t("placeholder.enter", {
                          title: t(`field.${COMMON_FIELD.MSO.field}`),
                        }),
                        register,
                        true
                      )}
                    </FormGroup>
                  </Col>

                  {/* Mã số thuế */}
                  <Col>
                    <FormGroup className="mb-2">
                      {generateInputField(
                        t(`field.${COMMON_FIELD.MST.field}`),
                        true,
                        "text",
                        errors,
                        touchedFields,
                        COMMON_FIELD.MST.field,
                        "XXXXXXXXXX-XXX (10 hoặc 14 kí tự)",
                        register,
                        disableForm,
                        "",
                        control,
                        false,
                        true
                      )}
                    </FormGroup>
                  </Col>
                  {/* CQT quản lý */}
                  <Col>
                    <FormGroup className="mb-2">
                      {generateInputField(
                        t(`field.${COMMON_FIELD.CQTQLY.field}`),
                        true,
                        "text",
                        errors,
                        touchedFields,
                        COMMON_FIELD.CQTQLY.field,
                        t("placeholder.enter", {
                          title: t(`field.${COMMON_FIELD.CQTQLY.field}`),
                        }),
                        register,
                        disableForm
                      )}
                    </FormGroup>
                  </Col>
                  {/* Mã CQT quản lý */}
                  <Col>
                    <FormGroup className="mb-2">
                      {generateInputField(
                        t(`field.${COMMON_FIELD.MCQTQLY.field}`),
                        true,
                        "text",
                        errors,
                        touchedFields,
                        COMMON_FIELD.MCQTQLY.field,
                        t("placeholder.enter", {
                          title: t(`field.${COMMON_FIELD.MCQTQLY.field}`),
                        }),
                        register,
                        disableForm
                      )}
                    </FormGroup>
                  </Col>
                  {/* Người liên hệ */}
                  <Col>
                    <FormGroup className="mb-2">
                      {generateInputField(
                        t(`field.${COMMON_FIELD.NLHE.field}`),
                        true,
                        "text",
                        errors,
                        touchedFields,
                        COMMON_FIELD.NLHE.field,
                        t("placeholder.enter", {
                          title: t(`field.${COMMON_FIELD.NLHE.field}`),
                        }),
                        register,
                        disableForm
                      )}
                    </FormGroup>
                  </Col>
                  {/* Địa chỉ liên hệ */}
                  <Col>
                    <FormGroup className="mb-2">
                      {generateInputField(
                        t(`field.${COMMON_FIELD.DCLHE.field}`),
                        true,
                        "text",
                        errors,
                        touchedFields,
                        COMMON_FIELD.DCLHE.field,
                        t("placeholder.enter", {
                          title: t(`field.${COMMON_FIELD.DCLHE.field}`),
                        }),
                        register,
                        disableForm
                      )}
                    </FormGroup>
                  </Col>
                  {/* Địa chỉ thư điện tử */}
                  <Col>
                    <FormGroup className="mb-2">
                      {generateInputField(
                        t(`field.${COMMON_FIELD.DCTDTU.field}`),
                        true,
                        "text",
                        errors,
                        touchedFields,
                        COMMON_FIELD.DCTDTU.field,
                        t("placeholder.enter", {
                          title: t(`field.${COMMON_FIELD.DCTDTU.field}`),
                        }),
                        register,
                        disableForm
                      )}
                    </FormGroup>
                  </Col>
                  {/* Điện thoại liên hệ */}
                  <Col>
                    <FormGroup className="mb-2">
                      {generateInputField(
                        t(`field.${COMMON_FIELD.DTLHE.field}`),
                        true,
                        "text",
                        errors,
                        touchedFields,
                        COMMON_FIELD.DTLHE.field,
                        t("placeholder.enter", {
                          title: t(`field.${COMMON_FIELD.DTLHE.field}`),
                        }),
                        register,
                        disableForm
                      )}
                    </FormGroup>
                  </Col>
                  {/* Địa danh */}
                  <Col>
                    <FormGroup className="mb-2">
                      {generateInputField(
                        t(`field.${COMMON_FIELD.DDANH.field}`),
                        true,
                        "text",
                        errors,
                        touchedFields,
                        COMMON_FIELD.DDANH.field,
                        t("placeholder.enter", {
                          title: t(`field.${COMMON_FIELD.DDANH.field}`),
                        }),
                        register,
                        disableForm
                      )}
                    </FormGroup>
                  </Col>
                  {/* Ngày lập */}
                  <Col>
                    <FormGroup className="mb-2">
                      {generateDateField(
                        t(`field.${COMMON_FIELD.NLAP.field}`),
                        "",
                        true,
                        errors,
                        COMMON_FIELD.NLAP.field,
                        "DD/MM/YYYY",
                        true,
                        control,
                        optionDateLocale
                      )}
                    </FormGroup>
                  </Col>
                </Row>
                <div className="custom-form-heading  mt-1">
                  <strong>
                    1. Danh sách chứng thư số sử dụng để lập hoá đơn uỷ nhiệm
                  </strong>
                </div>
                {generateTableCAS(
                  LIST_CAS_FIELD.field,
                  LIST_CAS_FIELD,
                  fieldsCAS,
                  removeCAS,
                  addNewLineCAS
                )}
                <div className="custom-form-heading  mt-1">
                  <strong>
                    2. Danh sách đăng ký thay đổi thông tin đăng ký sử dụng HĐĐT
                    khi ủy nhiệm/nhận ủy nhiệm lập hoá đơn
                  </strong>
                </div>
                {generateTableInvoices(
                  LIST_INVOICES_FIELD.field,
                  LIST_INVOICES_FIELD,
                  fieldsInvoices,
                  removeInvoices,
                  addNewLineInvoices
                )}
              </div>
            </ModalBody>
            <ModalFooter>
              <React.Fragment>
                {(dataDetail?.mode === MODE_FORM.ADD ||
                  dataDetail?.mode === MODE_FORM.EDIT) && (
                  <Button
                    type="button"
                    color={
                      dataDetail?.mode === MODE_FORM.ADD ? "primary" : "success"
                    }
                    className="btn-label"
                    disabled={loadingSubmitCreate || loadingSubmitEdit}
                    onClick={handleSubmit(submitForm)}
                  >
                    <i className="fas fa-save label-icon"></i>
                    {t(`button.${dataDetail?.mode}`)}
                  </Button>
                )}
                {dataDetail?.mode === MODE_FORM.VIEW &&
                  detailRegistryDelegate?.resource_id && (
                    <Button
                      type="button"
                      color="primary"
                      className="btn-label"
                      onClick={() => {
                        dispatch(
                          downloadXmlRegistryDelegate(
                            detailRegistryDelegate?.resource_id,
                            detailRegistryDelegate?.ten
                          )
                        );
                      }}
                    >
                      <i className="bx bx-download label-icon"></i>
                      Download XML
                    </Button>
                  )}
                {detailRegistryDelegate?.auth_status === AUTH_STATUS_NEW &&
                  dataDetail?.mode === MODE_FORM.VIEW && (
                    <Button
                      type="button"
                      color="success"
                      className="btn-label"
                      onClick={() => {
                        toggleReleaseModal();
                      }}
                    >
                      <i className="bx bx-send label-icon"></i>
                      Phát hành tờ khai
                    </Button>
                  )}
              </React.Fragment>
            </ModalFooter>
          </React.Fragment>
        )}
      </div>
    </Modal>
  );
};

DetailData.propTypes = {
  toggleReleaseModal: PropTypes.func,
  toggle: PropTypes.func,
  isOpen: PropTypes.bool,
  dataDetail: PropTypes.object,
  t: PropTypes.any,
  i18n: PropTypes.any,
};

export default DetailData;
